import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Scale } from 'lucide-react';
const tableData = [{
  sin: 'Seguir probando dietas que no funcionan',
  costo: 'Frustración acumulada + dinero perdido'
}, {
  sin: 'Vivir con la panza hinchada todos los días',
  costo: 'Incomodidad constante + ropa que no te queda'
}, {
  sin: 'Arrastrarte por las tardes sin energía',
  costo: 'Productividad perdida + vida social limitada'
}, {
  sin: 'Ansiedad sin control ni herramientas',
  costo: 'Calidad de vida deteriorada'
}, {
  sin: 'Consultas médicas sin soluciones concretas',
  costo: 'Más de $15.000 en consultas sin resultados'
}, {
  sin: 'Suplementos caros sin saber cuáles funcionan',
  costo: 'Miles de pesos en productos que no usás'
}];
export function CostComparison() {
  return <section className="py-20 bg-brand-card" data-id="element-39">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-40">
        <FadeIn className="text-center mb-12" data-id="element-41">
          <Scale className="w-12 h-12 text-brand-accent mx-auto mb-4" data-id="element-42" />
          <h2 className="text-3xl font-bold" data-id="element-43">⚖️ ¿CUÁNTO CUESTA NO TENERLO?</h2>
        </FadeIn>

        <FadeIn delay={0.1} className="mb-12 overflow-x-auto" data-id="element-44">
          <table className="w-full text-left border-collapse min-w-[600px] bg-brand-cream rounded-2xl overflow-hidden border border-brand-border shadow-sm" data-id="element-45">
            <thead data-id="element-46">
              <tr className="border-b border-brand-border bg-brand-card" data-id="element-47">
                <th className="p-5 text-brand-dark font-bold w-1/2" data-id="element-48">
                  Sin Megapack
                </th>
                <th className="p-5 text-brand-terracotta font-bold w-1/2" data-id="element-49">
                  Costo real
                </th>
              </tr>
            </thead>
            <tbody data-id="element-50">
              {tableData.map((row, i) => <tr key={i} className="border-b border-brand-border hover:bg-brand-card/50 transition-colors" data-id="element-51">
                  <td className="p-5 text-brand-dark" data-id="element-52">{row.sin}</td>
                  <td className="p-5 text-brand-terracotta font-medium" data-id="element-53">
                    {row.costo}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </FadeIn>

        <FadeIn delay={0.2} className="text-center" data-id="element-54">
          <h3 className="text-2xl md:text-3xl font-bold text-brand-dark mb-4" data-id="element-55">
            Podés empezar en 5 minutos.
          </h3>
        </FadeIn>
      </div>
    </section>;
}